import urlApi from "./urlApi";
export var GET_DOISER_REQUEST = 'GET_DOISER_REQUEST';
export var GET_DOISER_REQUEST_SUCCESS = 'GET_DOISER_REQUEST_SUCCESS';
export var GET_DOISER_REQUEST_ERROR = 'GET_DOISER_REQUEST_ERROR';
export function getDoiser(idArea, idCountry) {
    return function (dispatch) {
        dispatch({
            type: GET_DOISER_REQUEST,
        });
        urlApi().getDosier(idArea, idCountry).then(function (res) {
            dispatch({
                type: GET_DOISER_REQUEST_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: GET_DOISER_REQUEST_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getDoiser.js.mapimport urlApi from "./urlApi";
export var GET_DOISER_REQUEST = 'GET_DOISER_REQUEST';
export var GET_DOISER_REQUEST_SUCCESS = 'GET_DOISER_REQUEST_SUCCESS';
export var GET_DOISER_REQUEST_ERROR = 'GET_DOISER_REQUEST_ERROR';
export function getDoiser(idArea, idCountry) {
    return function (dispatch) {
        dispatch({
            type: GET_DOISER_REQUEST,
        });
        urlApi().getDosier(idArea, idCountry).then(function (res) {
            dispatch({
                type: GET_DOISER_REQUEST_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: GET_DOISER_REQUEST_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getDoiser.js.map